(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    class ProductGallery {
    constructor(container) {
      this.container = container;
      this.slides = container.querySelectorAll('.product-gallery__slide');
      this.thumbs = container.querySelectorAll('.product-gallery__thumb');
      this.prevBtn = container.querySelector('[data-gallery-prev]');
      this.nextBtn = container.querySelector('[data-gallery-next]');
      this.zoomTriggers = container.querySelectorAll('[data-zoom-trigger]');
      this.zoomModal = document.querySelector('[data-zoom-modal]');
      this.currentIndex = 0;

      this.init();
    }

    init() {
      // Thumbnail clicks
      this.thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => this.goTo(index));
      });

      // Navigation
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.prev());
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.next());
      }

      // Zoom
      this.zoomTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => this.openZoom(e));
      });

      if (this.zoomModal) {
        this.zoomModal.querySelector('[data-zoom-close]').addEventListener('click', () => this.closeZoom());
        this.zoomModal.addEventListener('click', (e) => {
          if (e.target === this.zoomModal) this.closeZoom();
        });
      }

      // Keyboard navigation
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.zoomModal && !this.zoomModal.hidden) {
          this.closeZoom();
        }
      });
    }

    goTo(index) {
      this.slides[this.currentIndex].classList.remove('is-active');
      this.thumbs[this.currentIndex]?.classList.remove('is-active');

      this.currentIndex = index;

      this.slides[this.currentIndex].classList.add('is-active');
      this.thumbs[this.currentIndex]?.classList.add('is-active');

      // Scroll thumb into view
      this.thumbs[this.currentIndex]?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    prev() {
      const newIndex = this.currentIndex === 0 ? this.slides.length - 1 : this.currentIndex - 1;
      this.goTo(newIndex);
    }

    next() {
      const newIndex = this.currentIndex === this.slides.length - 1 ? 0 : this.currentIndex + 1;
      this.goTo(newIndex);
    }

    openZoom(e) {
      const img = e.target.closest('.product-gallery__image-wrapper').querySelector('.product-gallery__image');
      const zoomSrc = img.dataset.zoomSrc || img.src;
      
      this.zoomModal.querySelector('[data-zoom-image]').src = zoomSrc;
      this.zoomModal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    closeZoom() {
      this.zoomModal.hidden = true;
      document.body.style.overflow = '';
    }

    // Update gallery when variant changes
    updateForVariant(variantMediaId) {
      if (!variantMediaId) return;
      
      const index = Array.from(this.slides).findIndex(
        slide => slide.dataset.mediaId == variantMediaId
      );
      
      if (index !== -1) {
        this.goTo(index);
      }
    }
  }

  // Initialize
  document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
    new ProductGallery(gallery);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media"] && !Shopify.designMode) return;
  try {
    class ProductMedia {
  constructor(el) {
    this.container = el;
    this.items = el.querySelectorAll('[data-media-index]');
    this.thumbs = el.querySelectorAll('[data-thumb]');
    this.thumbsContainer = el.querySelector('[data-thumbs-scroll]');
    this.dots = el.querySelectorAll('[data-media-dot]');
    this.prevBtn = el.querySelector('[data-media-prev]');
    this.nextBtn = el.querySelector('[data-media-next]');
    this.currentIndex = 0;

    // Find initial active
    this.items.forEach((item, i) => {
      if (item.classList.contains('is-active')) this.currentIndex = i;
    });

    this.bindEvents();
    this.preloadImages();
  }

  bindEvents() {
    // Thumbnails
    this.thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => this.goTo(parseInt(thumb.dataset.thumb)));
    });

    // Dots
    this.dots.forEach(dot => {
      dot.addEventListener('click', () => this.goTo(parseInt(dot.dataset.mediaDot)));
    });

    // Arrows
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prev());
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.next());

    // Swipe support
    let startX = 0;
    const main = this.container.querySelector('.product-media__main');
    main.addEventListener('touchstart', e => startX = e.touches[0].clientX, { passive: true });
    main.addEventListener('touchend', e => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) diff > 0 ? this.next() : this.prev();
    }, { passive: true });
  }

  preloadImages() {
    // Preload adjacent images
    const preloadIndexes = [
      this.currentIndex - 1,
      this.currentIndex + 1,
      this.currentIndex + 2
    ];
    
    preloadIndexes.forEach(index => {
      if (index >= 0 && index < this.items.length) {
        const img = this.items[index]?.querySelector('img');
        if (img && img.loading === 'lazy') {
          img.loading = 'eager';
        }
      }
    });
  }

  goTo(index) {
    if (index < 0) index = this.items.length - 1;
    if (index >= this.items.length) index = 0;

    // Update main gallery
    this.items[this.currentIndex]?.classList.remove('is-active');
    this.thumbs[this.currentIndex]?.classList.remove('is-active');
    this.dots[this.currentIndex]?.classList.remove('is-active');

    this.currentIndex = index;

    this.items[this.currentIndex]?.classList.add('is-active');
    this.thumbs[this.currentIndex]?.classList.add('is-active');
    this.dots[this.currentIndex]?.classList.add('is-active');

    // Preload next images
    this.preloadImages();
  }

  prev() { this.goTo(this.currentIndex - 1); }
  next() { this.goTo(this.currentIndex + 1); }

  selectByMediaId(mediaId) {
    const item = this.container.querySelector(`[data-media-id="${mediaId}"]`);
    if (item) this.goTo(parseInt(item.dataset.mediaIndex));
  }
}

document.querySelectorAll('[data-product-media]').forEach(el => {
  el.productMedia = new ProductMedia(el);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-guide"] && !Shopify.designMode) return;
  try {
    (function() {
    const dialog = document.getElementById('size-guide-dialog');
    if (!dialog) return;

    const closeBtn = dialog.querySelector('.size-guide-dialog__close');
    
    // Close on button click
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        dialog.close();
      });
    }

    // Close on backdrop click
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) {
        dialog.close();
      }
    });

    // Close on Escape key
    dialog.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        dialog.close();
      }
    });

    // Expose open function globally
    window.openSizeGuide = function() {
      dialog.showModal();
    };
  })();
  } catch(e) { console.error(e); }
})();

})();
